export default {
  // 指令的定义
  mounted(el) {
    el.focus()
 }
}